import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=c0da4384&"
import script from "./MaterialView.vue?vue&type=script&lang=js&"
export * from "./MaterialView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports